module.exports = __webpack_public_path__ + "img/niu.042bca7a.png";